/** @format */

import {SensorCategoriesBunchType} from 'types';

import {CategoriesData, ValidCheck} from '../model';
import settingsImg from '../images/settings_suggest_icon.svg';
import qualityImg from '../images/quality_icon.svg';
import targetingImg from '../images/targeting_icon.svg';
import feedsImg from '../images/feeds_icon.svg';
import budgetImg from '../images/budget_icon.svg';
import kpiImg from '../images/kpi_icon.svg';

const categoryIcons: Record<SensorCategoriesBunchType, string> = {
  campaign_settings: settingsImg,
  ads_quality: qualityImg,
  targeting_semantic_kernel: targetingImg,
  feeds: feedsImg,
  budget: budgetImg,
  kpi: kpiImg,
};

export interface BunchData {
  icon: string;
  name: SensorCategoriesBunchType;
  sensors: string[];
  description: string;
  title: string;
}

const getBunchData = (categoriesData: CategoriesData[], validChecks: ValidCheck[]): BunchData[] => {
  return categoriesData
    .map(item => ({
      ...item,
      icon: categoryIcons[item.name],
    }))
    .filter((v, _) => {
      const checks = validChecks.filter(check => v['sensors'].includes(check.sensor.name));
      return checks.length > 0;
    });
};

export {getBunchData};
